export const translations = {
  en: {
    common: {
      apply: 'Apply',
      cancel: 'Cancel',
      close: 'Close',
      confirm: 'Confirm',
      continue: 'Continue',
      copied: 'Copied',
      copy: 'Copy',
      delete: 'Delete',
      edit: 'Edit',
      greeting: 'Hi, {{name}}',
      loading: 'Loading...',
      next: 'Next',
      previous: 'Previous',
      present: 'Present',
      save: 'Save',
      search: 'Search',
      submit: 'Submit',
    },
    account: {
      home: 'Home',
      profile: 'Profile',
      subscription: 'Subscription',
    },
    auth: {
      alreadyHaveAccount: 'Already have an account?',
      and: 'and',
      continueAgreement: "By continuing you agree to JobJourney's",
      createAccount: 'Create account',
      createAccountHeading: 'Create your JobJourney account',
      createAccountSubheading: 'Get set up in less than a minute',
      creatingAccount: 'Creating account...',
      email: 'Email',
      emailFirstError: 'Please enter your email first.',
      firstName: 'First name',
      forgotPassword: 'Forgot password?',
      googleSignInError: 'Google sign in failed. Please try again.',
      googleSignUpError: 'Google sign up failed, please try again.',
      hidePassword: 'Hide password',
      lastName: 'Last name',
      logIn: 'Log in',
      noAccount: "Don't have an account?",
      or: 'or',
      password: 'Password',
      passwordPlaceholder: 'Minimum 8 characters',
      privacyPolicy: 'Privacy Policy',
      registerError: 'Registration failed, please try again.',
      remember: 'Remember for 30 days',
      resend: 'Resend',
      sendCode: 'Send code',
      sendCodeFailed: 'Failed to send verification code',
      sendCodeSuccess: 'Verification code sent! Please check your inbox.',
      showPassword: 'Show password',
      signIn: 'Sign in',
      signInError: 'Unable to sign in. Please try again.',
      signUp: 'Sign up',
      signingIn: 'Signing in...',
      signingUp: 'Signing up...',
      terms: 'Terms',
      verificationCode: 'Verification code',
      verificationCodeError: 'Please enter the verification code sent to your email.',
      verificationCodePlaceholder: 'Enter the 6-digit code',
      welcomeBack: 'Welcome back!',
      welcomeBackSubheading: 'Please enter your details',
    },
    header: {
      jobs: 'Jobs',
      login: 'Login',
      openAssistant: 'Open Assistant',
      register: 'Register',
      sessionExpired: 'Your session has expired. Please login again.',
    },
    jobs: {
      board: 'Board',
      errorTitle: 'Something went wrong:',
      list: 'List',
      recentlyDeleted: 'Recently deleted',
      savedJobsTitle: 'Saved Jobs 📝',
      table: 'Table',
    },
    jobMarket: {
      activeFilters: '{{count}} active',
      agentScrapedJobs: 'Agent Scraped Jobs',
      batch: 'Batch #{{runId}}',
      deleteError: 'Error deleting job. Please try again.',
      extensionProcessError: 'Error processing jobs from extension',
      filtersHide: 'Hide Filters',
      filtersShow: 'Show Filters',
      foundCount: '{{count}} jobs found',
      goToSavedJobs: 'Go to Saved Jobs',
      jobsLoaded: '{{count}} jobs loaded',
      loadedExtensionJobs: 'Loaded {{count}} jobs from extension',
      loadedLocalJobs: 'Loaded {{count}} locally scraped jobs',
      loadingLocalJobs: 'Loading jobs from local agent...',
      localConnectionError: 'Failed to connect to the backend. Please try again.',
      noJobsPrompt: 'Open JobJourney Assistant extension to start scraping and view jobs here.',
      onThisPage: '{{count}} on this page',
      receivedExtensionJobs: 'Received {{count}} jobs from extension',
      receivingExtensionJobs: 'Receiving jobs from extension...',
      removed: 'Job removed from list',
      retrievedOn: 'Retrieved on {{date}}',
      showingRange: 'Showing {{start}} - {{end}} of {{total}} jobs',
      subtitle: 'Search results from your job boards and extension',
      takeSeconds: 'This may take a few seconds',
      title: 'Job Market',
    },
    dashboard: {
      activityTimeline: 'Activity Timeline',
      applicationStatus: 'Application Status',
      applied: 'Applied',
      assistant: 'JobJourney Assistant',
      assistantConnectedDescription:
        'Your extension is active. Visit job sites to save jobs or use the Job Market to discover opportunities.',
      assistantDescription:
        'Your ultimate companion for job hunting. Automatically track applications, analyze job descriptions, and manage your journey directly from your browser.',
      connected: 'Connected',
      coverLetterGeneration: 'Cover Letter Generation',
      coverLetters: 'Cover Letters',
      cvEvaluation: 'CV Evaluation',
      dashboardLoadError: 'Failed to load dashboard data. Please try again later.',
      dayWithJobJourney: 'Day {{count}} with JobJourney',
      dismissBanner: 'Dismiss banner',
      documents: 'Documents',
      dialogs: {
        associatedUser: 'Associated User',
        availableForChats: 'Available for Chats',
        bio: 'Bio',
        chats: 'Chats',
        description: 'Description',
        documentDetails: 'Document Details',
        downloadFile: 'Download File',
        education: 'Education',
        employment: 'Employment',
        featureId: 'Feature ID',
        featureUsageDetails: 'Feature Usage Details',
        fileSize: 'File Size',
        format: 'Format',
        freePlan: 'Free Plan',
        fullProfile: 'Full Profile',
        helpTopics: 'Help Topics',
        joined: 'Joined {{date}}',
        noActivityFound: 'No activity found',
        noBioProvided: 'No bio provided',
        noDescriptionAvailable: 'No description available.',
        noDocumentsFound: 'No documents found',
        noEducationAdded: 'No education added',
        noEmploymentAdded: 'No employment history added',
        noHelpTopicsListed: 'No help topics listed',
        noNotesAdded: 'No notes added.',
        noSavedJobsFound: 'No saved jobs found',
        noSkillsAdded: 'No skills added',
        notSet: 'Not Set',
        notes: 'Notes',
        overview: 'Overview',
        owner: 'Owner',
        previewText: 'Preview Text',
        proActive: 'PRO Active',
        rating: 'Rating ({{count}})',
        recentActivity: 'Recent Activity',
        recentDocuments: 'Recent Documents',
        recentSavedJobs: 'Recent Saved Jobs',
        saved: 'Saved: {{date}}',
        savedJobDetails: 'Saved Job Details',
        searchPost: 'Search post...',
        type: 'Type',
        unavailable: 'Unavailable',
        unknown: 'Unknown',
        uploaded: 'Uploaded',
        usedOn: 'Used on {{date}}',
        user: 'User',
        userDetails: 'User Details',
        viewDocumentDetails: 'View document details',
        viewFeatureUsageDetails: 'View feature usage details',
        viewOriginalJob: 'View Original Job',
        viewSavedJobDetails: 'View saved job details',
        viewUserDetails: 'View user details',
      },
      featureUsage: 'Feature Usage',
      finalInterview: 'Final Interview',
      getExtension: 'Get Extension',
      hello: 'Hello,',
      interviews: 'Interviews',
      jobsSearched: 'Jobs Searched',
      loading: 'Loading your dashboard...',
      manage: 'Manage',
      metaDescription:
        'Track your JobJourney activity, saved jobs, documents, portfolio visits, and AI feature usage.',
      notAFit: 'Not a Fit',
      offered: 'Offered',
      portfolioVisits: 'Visits',
      resume: 'Resume',
      saved: 'Saved',
      saveJobsBanner: 'Save jobs from LinkedIn, Indeed, SEEK & more with one click',
      startSearching: 'Start Searching',
      title: 'Dashboard',
      totalViewsThisMonth: 'Total views this month',
      uses: 'uses',
      welcomeBack: 'Welcome back 👋',
    },
    cvEvaluation: {
      action: 'Action',
      evaluationDescription:
        'Evaluation for {{jobTitle}} at {{companyName}}. This score reflects how well your profile aligns with the job requirements.',
      example: 'Example',
      improvements: 'Improvements',
      matchAnalysis: 'Match Analysis',
      missing: 'Missing',
      noImprovements: 'No specific improvements identified.',
      noResults: 'No evaluation results available',
      noStrengths: 'No specific strengths identified.',
      none: 'None',
      partialMatch: 'Partial Match',
      skillsBreakdown: 'Skills Breakdown',
      strengths: 'Strengths',
      strongMatch: 'Strong Match',
    },
    language: {
      english: 'English',
      label: 'Language',
      simplifiedChinese: '简体中文',
    },
    menu: {
      close: 'Close menu',
      dockSidebar: 'Dock Sidebar',
      madeBy: 'made by Robert Wang',
      navigation: 'Navigation',
      undockSidebar: 'Undock Sidebar',
    },
    nav: {
      aiLab: 'AI Lab',
      coffeeChats: 'Coffee Chats',
      dashboard: 'Dashboard',
      docs: 'Docs',
      globalDashboard: 'Global Dashboard',
      jobMarket: 'Job Market',
      jobicorn: 'Jobicorn',
      marketReports: 'Market Reports',
      oneMinPortfolio: '1 min Portfolio',
      profile: 'Profile',
      savedJobs: 'Saved Jobs',
      treeHole: 'Tree Hole',
    },
    profile: {
      addTitle: 'Add Title',
      autoApply: 'Auto Apply',
      complete: 'Profile Complete!',
      completion: 'Profile Completion',
      completionPrompt: 'Complete your profile to improve job matching',
      education: 'Education',
      experience: 'Experience',
      hello: 'HELLO',
      initializeFromCv: 'Initialize from CV',
      loading: 'Loading profile data...',
      location: 'Location',
      myCv: 'My CV',
      personalInfo: 'Personal Info',
      projects: 'Projects',
      skills: 'Skills',
      updateFromCv: 'Update from CV',
      user: 'USER.',
    },
    coffeeChat: {
      availableCount: '{{count}} people available to help',
      createProfile: 'Create profile',
      createProfileCta: 'Create Profile',
      discover: 'Discover',
      empty: 'No profiles found. Try adjusting your filters.',
      fetchProfilesError: 'Failed to fetch profiles',
      hiddenSuccess: 'You are now hidden from discovery',
      hideFilters: 'Hide Filters',
      myProfile: 'My Profile',
      myRequests: 'My Requests',
      noProfilePrompt: 'Create a profile to appear in coffee chat discovery',
      openDescription: "I'm open to coffee chats and happy to help others",
      openTitle: 'Open to coffee chats',
      profileRequired: 'Profile Required',
      profileRequiredDescription: 'Create a profile to start sending and receiving coffee chat requests.',
      showFilters: 'Show Filters',
      subtitle: 'Connect with others who can help with your job search journey',
      title: 'Coffee Chats',
      updateAvailabilityError: 'Failed to update availability',
      visibleSuccess: 'You are now visible in discovery',
    },
    portfolioBuilder: {
      aiError: 'An error occurred while processing your CV',
      aiUpdateError: 'An error occurred while updating your profile',
      allSet: 'You are all set!',
      allSetDescription: 'Your profile is ready. Choose a template on the right to generate your portfolio.',
      applied: 'Applied',
      apply: 'Apply',
      browserNoVideo: 'Your browser does not support the video tag.',
      chooseTemplate: 'Choose a Template',
      confirmDescription: 'Confirm replacing your profile data before building the portfolio',
      confirmMessage: 'Confirming will update the profile data used to generate your portfolio.',
      confirmTitle: 'Confirm Portfolio Profile Update',
      failedApply: 'Failed to apply template',
      failedCoffeeChatPublic: 'Failed to make your Coffee Chat profile public. You can try again later.',
      failedProcess: 'Failed to process CV. Please try again.',
      failedUpdate: 'Failed to update profile',
      initializeWithAi: 'Initialize with AI',
      initializeWithAiDescription: 'Upload your CV/Resume and let our AI build your portfolio instantly.',
      portfolioPublic: 'Your Coffee Chat profile is now public!',
      preview: 'Preview',
      previewLabel: '{{name}} Preview',
      processing: 'Processing...',
      processingCv: 'Processing Your CV',
      profileUpdated: 'CV processed successfully! Your profile has been updated.',
      reuploadCv: 'Re-upload CV',
      saving: 'Saving...',
      subtitle: 'Create your professional portfolio in seconds with AI.',
      templateApplied: 'Template applied successfully!',
      title: '1 min Portfolio',
      updateWarning: 'This replaces your current profile information with the AI-extracted CV data.',
      uploadCv: 'Upload CV',
      yesUpdateProfile: 'Yes, Update My Profile',
    },
    landing: {
      allRightsReserved: 'All rights reserved.',
      browserExtension: 'Browser Extension',
      careers: 'Careers',
      company: 'Company',
      connect: 'Connect',
      contact: 'Contact',
      documentation: 'Documentation',
      featureSuite: 'Feature suite',
      features: 'Features',
      featureCarouselDescription:
        'Slide through the JobJourney co-pilots that keep job discovery, outreach, and interview prep completely in sync.',
      featureCarouselTitle:
        'All of your sourcing, tracking, and storytelling tools in one clean carousel',
      footerDescription:
        'Your AI-powered job search assistant that helps you find and land your dream job.',
      footerProduct: 'Product',
      goToFeature: 'Go to {{label}}',
      helpCenter: 'Help Center',
      metaDescription: 'JobJourney helps you find, apply, and track your dream job with AI-powered tools',
      portfolio: 'Portfolio',
      posted: 'Posted {{date}}',
      pricing: 'Pricing',
      privacy: 'Privacy',
      product: 'Product',
      resources: 'Resources',
      recentlyPosted: 'Recently posted',
      showNextFeature: 'Show next feature',
      showPreviousFeature: 'Show previous feature',
      signInUp: 'Sign In / Up',
      terms: 'Terms',
      titleSuffix: 'Your AI Job Search Assistant',
      preview: {
        aiPortfolioAlt: 'JobJourney AI portfolio preview',
        introMuted: 'Everything you need to land the next role:',
        introRest: 'JobJourney keeps sourcing, tracking, and storytelling in sync',
        moveForward: 'Move Forward',
        portfolioDescription:
          'Create stunning portfolios that spotlight your strengths. Choose a polished template, pull in project stats, and publish to a custom domain in minutes.',
        portfolioTitle: 'AI Portfolio Generation',
        timelineTitle: 'Timeline',
        updating: 'Updating...',
        assistant: {
          autoSaved: 'Jobs are automatically saved to your JobJourney tracker',
          country: 'Australia',
          keyword: 'Software Engineer',
          resultDescription: 'Design and develop modern web applications with thoughtful UX collaboration.',
          resultSalary: '$80,000 - $100,000 a year',
          resultTitle: 'Software Engineer (Full Stack)',
          resultType: 'Full-time',
          searchAcross: 'Search across multiple platforms simultaneously',
          secondaryDescription:
            'Run omni-channel experiments with product partners to deliver weekly conversion lift.',
          secondarySalary: '$120,000 - $142,000 + bonus',
          secondaryTitle: 'Growth Marketing Lead',
          secondaryType: 'Hybrid',
          syncSearches: 'Sync LinkedIn, Indeed, and SEEK searches',
          viewJob: 'View Job',
        },
        cvEvaluation: {
          companyName: 'TechCorp',
          improvements: [
            'Consider adding more specific examples of microservices architecture experience',
            'Highlight experience with GraphQL APIs to match the job requirements',
            'Include metrics and KPIs to quantify the impact of your previous projects',
          ],
          jobTitle: 'Senior Full-Stack Engineer',
          skillsAnalysis: [
            { comment: 'Expert level experience', matchLevel: 'strong', skill: 'React' },
            { comment: '3+ years of production use', matchLevel: 'strong', skill: 'TypeScript' },
            { comment: 'Backend development experience', matchLevel: 'strong', skill: 'Node.js' },
            { comment: 'Some database experience', matchLevel: 'partial', skill: 'PostgreSQL' },
            { comment: 'Not mentioned in resume', matchLevel: 'missing', skill: 'GraphQL' },
            { comment: 'Basic knowledge mentioned', matchLevel: 'partial', skill: 'Kubernetes' },
            { comment: 'Cloud deployment experience', matchLevel: 'strong', skill: 'AWS' },
            { comment: 'Container orchestration', matchLevel: 'strong', skill: 'Docker' },
          ],
          strengths: [
            'Strong experience with React and TypeScript, matching the core tech stack requirements',
            'Proven track record of building scalable applications with 5+ years of full-stack development',
            'Excellent problem-solving skills demonstrated through multiple complex projects',
            'Experience with modern DevOps practices including CI/CD and cloud deployment',
          ],
        },
        multiPlatformJobs: [
          {
            description:
              'Design analytics workflows that help product teams collaborate and ship insight-led updates.',
            jobType: 'Full-time',
            location: 'Remote - United States',
            postedDate: '2 days ago',
            salary: '$155k - $180k - Equity',
            title: 'Product Designer',
          },
          {
            description:
              'Run omni-channel experiments with product partners to deliver weekly conversion lift.',
            jobType: 'Hybrid',
            location: 'Remote - North America',
            postedDate: '4 days ago',
            salary: '$120k - $142k + bonus',
            title: 'Growth Marketing Lead',
          },
          {
            description:
              'Launch Canva enterprise playbooks and surface feedback from account champions.',
            jobType: 'On-site',
            location: 'Sydney, Australia',
            postedDate: '5 days ago',
            salary: '$130k - $145k + bonus',
            title: 'Customer Success Lead',
          },
          {
            description:
              'Ship velocity tooling that keeps global software teams releasing high-impact features.',
            jobType: 'Remote',
            location: 'Remote - Europe',
            postedDate: '1 week ago',
            salary: 'EUR 120k - EUR 140k',
            title: 'Full-stack Engineer',
          },
        ],
        savedJobs: [
          {
            description:
              'Design analytics workflows that help product teams collaborate and ship insight-led updates. Work with cross-functional teams to create intuitive user experiences.',
            employmentTypes: 'Full-time',
            location: 'Remote - United States',
            name: 'Product Designer',
            notes: ['Portfolio walk-through scheduled for Nov 7. Prepare case studies on analytics dashboards.'],
            requiredSkills: 'Figma, UI/UX Design, Prototyping, Design Systems, User Research',
            stage: 'Interview',
            workArrangement: 'Remote',
          },
          {
            description:
              'Run omni-channel experiments with product partners to deliver weekly conversion lift. Lead growth initiatives and optimize marketing funnels.',
            employmentTypes: 'Full-time',
            location: 'Remote - North America',
            name: 'Growth Marketing Lead',
            notes: ['Complete case study on growth experiment by Nov 9. Focus on omni-channel approach.'],
            requiredSkills: 'Growth Marketing, A/B Testing, Analytics, Product Marketing, SQL, Data Analysis',
            stage: 'Assessment',
            workArrangement: 'Hybrid',
          },
          {
            description:
              'Launch Canva enterprise playbooks and surface feedback from account champions. Drive customer satisfaction and retention.',
            employmentTypes: 'Full-time',
            location: 'Sydney, Australia',
            name: 'Customer Success Lead',
            notes: ['Hiring manager sync went well. Share adoption playbook draft as follow-up.'],
            requiredSkills: 'Customer Success, Account Management, SaaS, Stakeholder Management, Communication',
            stage: 'Interview',
            workArrangement: 'On-site',
          },
        ],
        timelineSteps: {
          applied: {
            description: 'Applied for this position',
            title: 'Application Submitted',
          },
          finalInterview: {
            description: 'Completed final interview',
            title: 'Final Interview',
          },
          initialInterview: {
            description: 'Completed first interview',
            title: 'Initial Interview',
          },
          notFit: {
            description: 'Marked as not a fit',
          },
          saved: {
            description: 'Added to your saved jobs',
            title: 'Job Saved',
          },
        },
      },
      featuresSection: {
        extensionDescription:
          'The extension parses comp, seniority, visa status, and recruiter info the moment a tab opens.',
        extensionLabel: 'Chrome copilot',
        extensionTitle: 'Clip any listing in seconds',
        extensionHighlights: [
          'Keyboard shortcut captures the listing and parsed metadata instantly.',
          'Inline AI callouts suggest the metrics and wins to mention when you reply.',
          'Saves straight to JobJourney with the correct board, seniority, and due dates.',
          'Keeps recruiter, hiring manager, and compensation intel linked to every save.',
          'Auto-fills outreach drafts with role context and your latest portfolio links.',
        ],
        multiPlatformDescription:
          'Plug one query into every major job board and keep the keeper with full context.',
        multiPlatformLabel: 'Unified sourcing',
        multiPlatformTitle: 'See every relevant role without juggling tabs',
        multiPlatformHighlights: [
          'One saved search fans out to LinkedIn, Indeed, Wellfound, YC Jobs, and more.',
          'Company intel, recruiter notes, and visa status stay attached to every role.',
          'Signals auto-tag seniority, geography, and compensation bands for clean views.',
          'Priority cues surface which recruiters have replied or are due for a nudge.',
          'Centralize saved roles, recruiter notes, and visa requirements without hopping tabs.',
          'Export shortlists with compensation bands, headcount plans, and visa status baked in.',
        ],
        resumeDescription:
          'Compare your resume to the job description with instant strengths, gaps, and edit checklists.',
        resumeLabel: 'AI resume evaluator',
        resumeTitle: 'Know exactly what to tweak before applying',
        resumeHighlights: [
          'Match score breakdown shows strengths and gaps before you hit submit.',
          'Skill coverage chart reveals which keywords need amplification.',
          'Actionable edits tell you exactly what metric or story to add.',
        ],
        storytellingDescription:
          'Transform wins into beautiful portfolios, interview recaps, and landing pages without touching design tools.',
        storytellingLabel: 'AI storytelling',
        storytellingTitle: 'Publish case studies and follow-ups automatically',
        storytellingHighlights: [
          'AI templates turn pipeline data into portfolios, case studies, and recaps.',
          'Personalized thank-you emails and updates ship with one click.',
          'Host everything on branded microsites that update themselves.',
        ],
        trackingDescription:
          'Stage-aware automations keep outreach, intros, and interviews synced across every view.',
        trackingLabel: 'Smart tracking',
        trackingTitle: 'Pipeline CRM that keeps every conversation moving',
        trackingHighlights: [
          'Two-click stage updates echo across Kanban, table, and calendar views.',
          'Notes, files, and interview prep checklists stay pinned to each opportunity.',
          'Reminders queue themselves for outreach, referrals, and follow-ups.',
        ],
      },
      stats: {
        error: 'Failed to load statistics',
        impactDescription:
          'Real results from real users. See how JobJourney is transforming the job search experience.',
        impactTitle: 'Our Impact by the Numbers',
        jobsDiscovered: 'Jobs Discovered',
        jobsDiscoveredDescription: 'opportunities uncovered across all platforms',
        jobsTracked: 'Jobs Tracked',
        jobsTrackedDescription: 'applications managed with JobJourney',
        successfulOffers: 'Successful Offers',
        successfulOffersDescription: 'dream jobs secured with our help',
        usersHelped: 'Users Helped',
        usersHelpedDescription: 'professionals guided toward their dream careers',
      },
      table: {
        application: 'application',
        applications: 'applications',
        defaultApplications: [
          {
            company: 'Nimbus Analytics',
            date: 'Nov 4, 2024',
            location: 'Remote - US',
            nextStep: 'Portfolio walk-through - Nov 7',
            role: 'Senior Product Designer',
            stage: 'Interview scheduled',
          },
          {
            company: 'Brightleaf Labs',
            date: 'Nov 2, 2024',
            location: 'Austin, TX',
            nextStep: 'Complete case study by Nov 9',
            role: 'Growth Marketing Manager',
            stage: 'Assessment sent',
          },
          {
            company: 'Atlas Support Co.',
            date: 'Oct 29, 2024',
            location: 'Toronto, CA',
            nextStep: 'Review compensation notes',
            role: 'Customer Success Lead',
            stage: 'Offer in review',
          },
          {
            company: 'Riverstone Tech',
            date: 'Oct 27, 2024',
            location: 'Chicago, IL',
            nextStep: 'Send follow-up message',
            role: 'Full-stack Engineer',
            stage: 'Awaiting response',
          },
        ],
        defaultSubtitle: 'Live updates from your JobJourney tracker',
        defaultTitle: 'Active applications',
        nextStep: 'Next step',
        opportunity: 'Opportunity',
        stage: 'Stage',
        synced: 'Synced moments ago',
        tracking: 'Tracking',
        updated: 'Updated',
      },
      story: {
        applyAria: 'Apply with better material',
        applyDescription:
          'Use your profile, projects, saved roles, and interview notes to create sharper cover letters, follow-ups, and portfolio pages for recruiters.',
        applyHeadline: 'Apply\nWith\nProof',
        applyLabel: 'Turn progress into stronger applications',
        applyMaterial: 'Application material',
        applicationDashboard: 'Application dashboard',
        aiEvaluation: 'AI evaluation',
        contextAria: 'Keep role context together',
        contextDescription:
          'A saved job should be more than a link. JobJourney keeps the role, notes, next step, and AI help together so you can pick up exactly where you left off.',
        contextHeadline: 'Keep\nThe\nContext',
        contextLabel: 'Every job with the details that matter',
        findAria: 'Find relevant roles faster',
        findDescription:
          'Search across the places candidates already use, then keep the promising jobs in one clean shortlist instead of losing them across browser tabs.',
        findHeadline: 'Find\nRoles\nFaster',
        findLabel: 'Less tab switching, more good roles',
        fitAria: 'Know what to improve before applying',
        fitDescription:
          'Compare your CV with the role, see what is strong, and fix the gaps before sending another generic application.',
        fitHeadline: 'Know\nYour\nFit',
        fitLabel: 'Resume feedback before you submit',
        followUps: 'Follow-ups and reminders are part of the job record',
        jobJourneyStory: 'JobJourney product story',
        multiPlatformSearch: 'Multi-platform search',
        pipelineAria: 'Track every next step',
        pipelineDescription:
          'See what needs attention today: roles to apply for, interviews to prepare, recruiters to follow up with, and offers to compare.',
        pipelineHeadline: 'Track\nEvery\nStep',
        pipelineLabel: 'No more spreadsheet drift',
        portfolioAndDocuments: 'Portfolio and documents',
        roleContext: 'Company, role, source, salary clues, and notes stay attached',
        roleDetailWorkspace: 'Role detail workspace',
        startFree: 'Start free',
        strongMatch: 'strong match',
        sourceIndeed: 'extra signal without extra tabs',
        sourceLinkedIn: 'roles worth reviewing',
        sourceSeek: 'local market coverage',
        stageApplied: 'log the submission',
        stageInterview: 'prep the next meeting',
        stageOffer: 'compare the outcome',
        stageSaved: 'shortlist the role',
        suggestionContext: 'AI suggestions are connected to the role you are reviewing',
        signalActualRole:
          'Strengths, missing keywords, and edits are shown against the actual role',
        signalFollowUp:
          'Use interview notes and outcomes to make every follow-up specific',
        signalGenerate:
          'Generate application material from the profile you already maintain',
        signalRecruiters: 'Show recruiters the projects and proof that match the role',
      },
      testimonials: {
        eyebrow: 'Testimonials',
        subtitle:
          'Click any face to see how JobJourney helped candidates search, track, and apply with less friction.',
        title: 'Job seekers making cleaner moves',
      },
    },
    aiLab: {
      error: 'Error',
      subtitle: 'Supercharge your job search with AI',
      title: 'AI Lab',
    },
    router: {
      loading: 'Loading...',
    },
  },
  'zh-CN': {
    common: {
      apply: '申请',
      cancel: '取消',
      close: '关闭',
      confirm: '确认',
      continue: '继续',
      copied: '已复制',
      copy: '复制',
      delete: '删除',
      edit: '编辑',
      greeting: '你好，{{name}}',
      loading: '加载中...',
      next: '下一页',
      previous: '上一页',
      present: '至今',
      save: '保存',
      search: '搜索',
      submit: '提交',
    },
    account: {
      home: '首页',
      profile: '个人资料',
      subscription: '订阅',
    },
    auth: {
      alreadyHaveAccount: '已有账号？',
      and: '和',
      continueAgreement: '继续即表示你同意 JobJourney 的',
      createAccount: '创建账号',
      createAccountHeading: '创建你的 JobJourney 账号',
      createAccountSubheading: '不到一分钟即可完成设置',
      creatingAccount: '正在创建账号...',
      email: '邮箱',
      emailFirstError: '请先输入邮箱。',
      firstName: '名',
      forgotPassword: '忘记密码？',
      googleSignInError: 'Google 登录失败，请重试。',
      googleSignUpError: 'Google 注册失败，请重试。',
      hidePassword: '隐藏密码',
      lastName: '姓',
      logIn: '登录',
      noAccount: '还没有账号？',
      or: '或',
      password: '密码',
      passwordPlaceholder: '至少 8 个字符',
      privacyPolicy: '隐私政策',
      registerError: '注册失败，请重试。',
      remember: '记住我 30 天',
      resend: '重新发送',
      sendCode: '发送验证码',
      sendCodeFailed: '验证码发送失败',
      sendCodeSuccess: '验证码已发送，请检查邮箱。',
      showPassword: '显示密码',
      signIn: '登录',
      signInError: '无法登录，请重试。',
      signUp: '注册',
      signingIn: '正在登录...',
      signingUp: '正在注册...',
      terms: '服务条款',
      verificationCode: '验证码',
      verificationCodeError: '请输入发送到邮箱的验证码。',
      verificationCodePlaceholder: '输入 6 位验证码',
      welcomeBack: '欢迎回来！',
      welcomeBackSubheading: '请输入你的登录信息',
    },
    header: {
      jobs: '职位',
      login: '登录',
      openAssistant: '打开助手',
      register: '注册',
      sessionExpired: '登录已过期，请重新登录。',
    },
    jobs: {
      board: '看板',
      errorTitle: '出现错误：',
      list: '列表',
      recentlyDeleted: '最近删除',
      savedJobsTitle: '已保存职位 📝',
      table: '表格',
    },
    jobMarket: {
      activeFilters: '{{count}} 个筛选已启用',
      agentScrapedJobs: 'Agent 抓取职位',
      batch: '批次 #{{runId}}',
      deleteError: '删除职位失败，请重试。',
      extensionProcessError: '处理插件职位时出错',
      filtersHide: '隐藏筛选',
      filtersShow: '显示筛选',
      foundCount: '找到 {{count}} 个职位',
      goToSavedJobs: '前往已保存职位',
      jobsLoaded: '已加载 {{count}} 个职位',
      loadedExtensionJobs: '已从插件加载 {{count}} 个职位',
      loadedLocalJobs: '已加载本地抓取的 {{count}} 个职位',
      loadingLocalJobs: '正在从本地 Agent 加载职位...',
      localConnectionError: '无法连接到后端，请重试。',
      noJobsPrompt: '打开 JobJourney Assistant 插件开始抓取，并在这里查看职位。',
      onThisPage: '本页 {{count}} 个',
      receivedExtensionJobs: '已从插件收到 {{count}} 个职位',
      receivingExtensionJobs: '正在接收插件职位...',
      removed: '职位已从列表移除',
      retrievedOn: '抓取日期 {{date}}',
      showingRange: '显示第 {{start}} - {{end}} 个，共 {{total}} 个职位',
      subtitle: '来自招聘平台和插件的搜索结果',
      takeSeconds: '这可能需要几秒钟',
      title: '职位市场',
    },
    dashboard: {
      activityTimeline: '活动时间线',
      applicationStatus: '申请状态',
      applied: '已申请',
      assistant: 'JobJourney 助手',
      assistantConnectedDescription: '你的插件已启用。访问招聘网站保存职位，或使用职位市场发现机会。',
      assistantDescription:
        '你的求职浏览器助手。自动追踪申请、分析职位描述，并直接在浏览器中管理求职进展。',
      connected: '已连接',
      coverLetterGeneration: '求职信生成',
      coverLetters: '求职信',
      cvEvaluation: 'CV 评估',
      dashboardLoadError: '仪表盘数据加载失败，请稍后再试。',
      dayWithJobJourney: '加入 JobJourney 的第 {{count}} 天',
      dismissBanner: '关闭提示',
      documents: '文档',
      dialogs: {
        associatedUser: '关联用户',
        availableForChats: '可接受 Coffee Chat',
        bio: '简介',
        chats: '聊天',
        description: '描述',
        documentDetails: '文档详情',
        downloadFile: '下载文件',
        education: '教育经历',
        employment: '工作经历',
        featureId: '功能 ID',
        featureUsageDetails: '功能使用详情',
        fileSize: '文件大小',
        format: '格式',
        freePlan: '免费计划',
        fullProfile: '完整资料',
        helpTopics: '可帮助主题',
        joined: '加入于 {{date}}',
        noActivityFound: '暂无活动',
        noBioProvided: '暂无简介',
        noDescriptionAvailable: '暂无描述。',
        noDocumentsFound: '暂无文档',
        noEducationAdded: '暂无教育经历',
        noEmploymentAdded: '暂无工作经历',
        noHelpTopicsListed: '暂无帮助主题',
        noNotesAdded: '暂无备注。',
        noSavedJobsFound: '暂无保存职位',
        noSkillsAdded: '暂无技能',
        notSet: '未设置',
        notes: '备注',
        overview: '概览',
        owner: '所有者',
        previewText: '预览文本',
        proActive: 'PRO 已启用',
        rating: '评分（{{count}}）',
        recentActivity: '近期活动',
        recentDocuments: '近期文档',
        recentSavedJobs: '近期保存职位',
        saved: '保存于：{{date}}',
        savedJobDetails: '已保存职位详情',
        searchPost: '搜索文章...',
        type: '类型',
        unavailable: '不可用',
        unknown: '未知',
        uploaded: '上传时间',
        usedOn: '使用于 {{date}}',
        user: '用户',
        userDetails: '用户详情',
        viewDocumentDetails: '查看文档详情',
        viewFeatureUsageDetails: '查看功能使用详情',
        viewOriginalJob: '查看原始职位',
        viewSavedJobDetails: '查看已保存职位详情',
        viewUserDetails: '查看用户详情',
      },
      featureUsage: '功能使用',
      finalInterview: '终面',
      getExtension: '获取插件',
      hello: '你好，',
      interviews: '面试',
      jobsSearched: '已搜索职位',
      loading: '正在加载仪表盘...',
      manage: '管理',
      metaDescription: '追踪你的 JobJourney 活动、已保存职位、文档、作品集访问量和 AI 功能使用情况。',
      notAFit: '不匹配',
      offered: '已获 Offer',
      portfolioVisits: '访问量',
      resume: '简历',
      saved: '已保存',
      saveJobsBanner: '一键从 LinkedIn、Indeed、SEEK 等网站保存职位',
      startSearching: '开始搜索',
      title: '仪表盘',
      totalViewsThisMonth: '本月总浏览量',
      uses: '次使用',
      welcomeBack: '欢迎回来 👋',
    },
    cvEvaluation: {
      action: '行动',
      evaluationDescription:
        '{{companyName}} 的 {{jobTitle}} 评估。这个分数反映你的资料与职位要求的匹配程度。',
      example: '示例',
      improvements: '改进建议',
      matchAnalysis: '匹配分析',
      missing: '缺失',
      noImprovements: '暂无具体改进建议。',
      noResults: '暂无评估结果',
      noStrengths: '暂无具体优势。',
      none: '无',
      partialMatch: '部分匹配',
      skillsBreakdown: '技能拆解',
      strengths: '优势',
      strongMatch: '高度匹配',
    },
    language: {
      english: 'English',
      label: '语言',
      simplifiedChinese: '简体中文',
    },
    menu: {
      close: '关闭菜单',
      dockSidebar: '固定侧边栏',
      madeBy: 'Robert Wang 制作',
      navigation: '导航',
      undockSidebar: '取消固定侧边栏',
    },
    nav: {
      aiLab: 'AI 实验室',
      coffeeChats: 'Coffee Chat',
      dashboard: '仪表盘',
      docs: '文档',
      globalDashboard: '全局仪表盘',
      jobMarket: '职位市场',
      jobicorn: 'Jobicorn',
      marketReports: '市场报告',
      oneMinPortfolio: '1 分钟作品集',
      profile: '个人资料',
      savedJobs: '已保存职位',
      treeHole: '树洞',
    },
    profile: {
      addTitle: '添加职位标题',
      autoApply: '自动申请',
      complete: '资料已完成！',
      completion: '资料完成度',
      completionPrompt: '完善资料以提升职位匹配效果',
      education: '教育经历',
      experience: '工作经历',
      hello: '你好',
      initializeFromCv: '从 CV 初始化',
      loading: '正在加载个人资料...',
      location: '地点',
      myCv: '我的 CV',
      personalInfo: '个人信息',
      projects: '项目',
      skills: '技能',
      updateFromCv: '从 CV 更新',
      user: '用户。',
    },
    coffeeChat: {
      availableCount: '{{count}} 位可提供帮助',
      createProfile: '创建资料',
      createProfileCta: '创建资料',
      discover: '发现',
      empty: '没有找到资料，请调整筛选条件。',
      fetchProfilesError: '获取资料失败',
      hiddenSuccess: '你已从发现页隐藏',
      hideFilters: '隐藏筛选',
      myProfile: '我的资料',
      myRequests: '我的请求',
      noProfilePrompt: '创建资料后即可出现在 Coffee Chat 发现页',
      openDescription: '我愿意 Coffee Chat，也乐于帮助其他人',
      openTitle: '开放 Coffee Chat',
      profileRequired: '需要先创建资料',
      profileRequiredDescription: '创建资料后即可发送和接收 Coffee Chat 请求。',
      showFilters: '显示筛选',
      subtitle: '连接能帮助你求职的人',
      title: 'Coffee Chats',
      updateAvailabilityError: '更新可见状态失败',
      visibleSuccess: '你已在发现页可见',
    },
    portfolioBuilder: {
      aiError: '处理 CV 时发生错误',
      aiUpdateError: '更新资料时发生错误',
      allSet: '已经准备好了！',
      allSetDescription: '你的资料已就绪。选择右侧模板即可生成作品集。',
      applied: '已应用',
      apply: '应用',
      browserNoVideo: '你的浏览器不支持视频标签。',
      chooseTemplate: '选择模板',
      confirmDescription: '生成作品集前，请确认是否替换你的资料数据',
      confirmMessage: '确认后，将更新用于生成作品集的资料数据。',
      confirmTitle: '确认更新作品集资料',
      failedApply: '模板应用失败',
      failedCoffeeChatPublic: '无法公开你的 Coffee Chat 资料，请稍后再试。',
      failedProcess: 'CV 处理失败，请重试。',
      failedUpdate: '更新资料失败',
      initializeWithAi: '用 AI 初始化',
      initializeWithAiDescription: '上传 CV/简历，让 AI 立即为你生成作品集资料。',
      portfolioPublic: '你的 Coffee Chat 资料已公开！',
      preview: '预览',
      previewLabel: '{{name}} 预览',
      processing: '处理中...',
      processingCv: '正在处理你的 CV',
      profileUpdated: 'CV 处理成功！你的资料已更新。',
      reuploadCv: '重新上传 CV',
      saving: '保存中...',
      subtitle: '用 AI 在几秒钟内创建专业作品集。',
      templateApplied: '模板已成功应用！',
      title: '1 分钟作品集',
      updateWarning: '这会用 AI 从 CV 中提取的数据替换当前资料信息。',
      uploadCv: '上传 CV',
      yesUpdateProfile: '确认更新我的资料',
    },
    landing: {
      allRightsReserved: '版权所有。',
      browserExtension: '浏览器插件',
      careers: '招聘',
      company: '公司',
      connect: '关注我们',
      contact: '联系',
      documentation: '文档',
      featureSuite: '功能套件',
      features: '功能',
      featureCarouselDescription:
        '浏览 JobJourney 的求职协作工具，让职位发现、沟通跟进和面试准备保持同步。',
      featureCarouselTitle: '把职位搜索、进度追踪和申请材料工具放进一个清晰的轮播里',
      footerDescription: 'AI 求职助手，帮助你找到并拿下理想工作。',
      footerProduct: '产品',
      goToFeature: '前往 {{label}}',
      helpCenter: '帮助中心',
      metaDescription: 'JobJourney 用 AI 工具帮助你寻找、申请并追踪理想工作',
      portfolio: '作品集',
      posted: '发布于 {{date}}',
      pricing: '价格',
      privacy: '隐私',
      product: '产品',
      resources: '资源',
      recentlyPosted: '最近发布',
      showNextFeature: '显示下一个功能',
      showPreviousFeature: '显示上一个功能',
      signInUp: '登录 / 注册',
      terms: '条款',
      titleSuffix: '你的 AI 求职助手',
      preview: {
        aiPortfolioAlt: 'JobJourney AI 作品集预览',
        introMuted: '拿下下一份工作需要的工具：',
        introRest: 'JobJourney 让职位搜索、进度追踪和故事呈现保持同步',
        moveForward: '推进阶段',
        portfolioDescription:
          '创建突出你优势的精美作品集。选择专业模板，导入项目数据，并在几分钟内发布到自定义域名。',
        portfolioTitle: 'AI 作品集生成',
        timelineTitle: '时间线',
        updating: '更新中...',
        assistant: {
          autoSaved: '职位会自动保存到你的 JobJourney 跟踪器',
          country: '澳大利亚',
          keyword: '软件工程师',
          resultDescription: '设计并开发现代 Web 应用，同时保持出色的用户体验协作。',
          resultSalary: '年薪 $80,000 - $100,000',
          resultTitle: '软件工程师（全栈）',
          resultType: '全职',
          searchAcross: '同时搜索多个招聘平台',
          secondaryDescription: '与产品团队一起运行多渠道实验，持续提升转化。',
          secondarySalary: '$120,000 - $142,000 + 奖金',
          secondaryTitle: '增长营销负责人',
          secondaryType: '混合办公',
          syncSearches: '同步 LinkedIn、Indeed 和 SEEK 搜索',
          viewJob: '查看职位',
        },
        cvEvaluation: {
          companyName: 'TechCorp',
          improvements: [
            '可以补充更多微服务架构经验的具体例子',
            '突出 GraphQL API 经验以匹配职位要求',
            '加入指标和 KPI 来量化过往项目影响',
          ],
          jobTitle: '高级全栈工程师',
          skillsAnalysis: [
            { comment: '专家级经验', matchLevel: 'strong', skill: 'React' },
            { comment: '3 年以上生产环境使用经验', matchLevel: 'strong', skill: 'TypeScript' },
            { comment: '后端开发经验', matchLevel: 'strong', skill: 'Node.js' },
            { comment: '具备一定数据库经验', matchLevel: 'partial', skill: 'PostgreSQL' },
            { comment: '简历中未提及', matchLevel: 'missing', skill: 'GraphQL' },
            { comment: '提到基础知识', matchLevel: 'partial', skill: 'Kubernetes' },
            { comment: '云部署经验', matchLevel: 'strong', skill: 'AWS' },
            { comment: '容器编排经验', matchLevel: 'strong', skill: 'Docker' },
          ],
          strengths: [
            'React 和 TypeScript 经验扎实，匹配核心技术栈要求',
            '5 年以上全栈开发经验，有构建可扩展应用的记录',
            '通过多个复杂项目展现出优秀的问题解决能力',
            '具备 CI/CD 和云部署等现代 DevOps 实践经验',
          ],
        },
        multiPlatformJobs: [
          {
            description: '设计数据分析流程，帮助产品团队协作并发布由洞察驱动的更新。',
            jobType: '全职',
            location: '远程 - 美国',
            postedDate: '2 天前',
            salary: '$155k - $180k - 股权',
            title: '产品设计师',
          },
          {
            description: '与产品伙伴一起运行多渠道实验，持续带来每周转化提升。',
            jobType: '混合办公',
            location: '远程 - 北美',
            postedDate: '4 天前',
            salary: '$120k - $142k + 奖金',
            title: '增长营销负责人',
          },
          {
            description: '推出 Canva 企业客户方案，并从关键客户那里收集反馈。',
            jobType: '现场办公',
            location: '澳大利亚悉尼',
            postedDate: '5 天前',
            salary: '$130k - $145k + 奖金',
            title: '客户成功负责人',
          },
          {
            description: '构建效率工具，帮助全球软件团队持续发布高影响力功能。',
            jobType: '远程',
            location: '远程 - 欧洲',
            postedDate: '1 周前',
            salary: 'EUR 120k - EUR 140k',
            title: '全栈工程师',
          },
        ],
        savedJobs: [
          {
            description:
              '设计数据分析流程，帮助产品团队协作并发布由洞察驱动的更新。与跨职能团队合作，打造直观的用户体验。',
            employmentTypes: '全职',
            location: '远程 - 美国',
            name: '产品设计师',
            notes: ['作品集讲解安排在 11 月 7 日。准备分析仪表盘相关案例。'],
            requiredSkills: 'Figma、UI/UX 设计、原型设计、设计系统、用户研究',
            stage: '面试',
            workArrangement: '远程',
          },
          {
            description:
              '与产品伙伴一起运行多渠道实验，持续带来每周转化提升。负责增长项目并优化营销漏斗。',
            employmentTypes: '全职',
            location: '远程 - 北美',
            name: '增长营销负责人',
            notes: ['11 月 9 日前完成增长实验案例研究，重点突出多渠道方法。'],
            requiredSkills: '增长营销、A/B 测试、数据分析、产品营销、SQL、数据分析',
            stage: '测评',
            workArrangement: '混合办公',
          },
          {
            description: '推出 Canva 企业客户方案，并从关键客户那里收集反馈。推动客户满意度和续约。',
            employmentTypes: '全职',
            location: '澳大利亚悉尼',
            name: '客户成功负责人',
            notes: ['与招聘经理的沟通很顺利。后续发送客户采用方案草稿。'],
            requiredSkills: '客户成功、客户管理、SaaS、利益相关方管理、沟通',
            stage: '面试',
            workArrangement: '现场办公',
          },
        ],
        timelineSteps: {
          applied: {
            description: '已申请该职位',
            title: '已提交申请',
          },
          finalInterview: {
            description: '已完成终面',
            title: '终面',
          },
          initialInterview: {
            description: '已完成初面',
            title: '初面',
          },
          notFit: {
            description: '已标记为不匹配',
          },
          saved: {
            description: '已添加到保存职位',
            title: '已保存职位',
          },
        },
      },
      featuresSection: {
        extensionDescription: '插件会在打开职位页面时解析薪资、级别、签证状态和招聘信息。',
        extensionLabel: 'Chrome 助手',
        extensionTitle: '几秒钟保存任何职位',
        extensionHighlights: [
          '用快捷键立即保存职位和解析出的信息。',
          'AI 提示会建议回复时应该强调的数据和亮点。',
          '直接保存到 JobJourney，并带上正确看板、级别和截止日期。',
          '把招聘人员、Hiring Manager 和薪资信息关联到每个职位。',
          '根据职位上下文和最新作品集自动生成沟通草稿。',
        ],
        multiPlatformDescription: '一个查询覆盖主要招聘平台，并把值得关注的职位完整保存。',
        multiPlatformLabel: '统一搜索',
        multiPlatformTitle: '不用在多个标签页之间来回切换，也能看到相关职位',
        multiPlatformHighlights: [
          '一个保存搜索可覆盖 LinkedIn、Indeed、Wellfound、YC Jobs 等平台。',
          '公司信息、招聘备注和签证状态会附在每个职位上。',
          '自动标记级别、地点和薪资区间，方便筛选。',
          '优先提示哪些招聘人员已回复或需要跟进。',
          '集中保存职位、招聘备注和签证要求，不用反复切换标签页。',
          '导出 shortlist 时包含薪资区间、招聘计划和签证状态。',
        ],
        resumeDescription: '把简历和职位描述对比，立即看到优势、差距和修改清单。',
        resumeLabel: 'AI 简历评估',
        resumeTitle: '申请前明确知道该改什么',
        resumeHighlights: [
          '匹配分数拆解会在提交前展示优势和缺口。',
          '技能覆盖图显示哪些关键词需要加强。',
          '可执行修改建议会说明该添加哪些数据或故事。',
        ],
        storytellingDescription:
          '把求职进展转成精美作品集、面试复盘和落地页，不需要设计工具。',
        storytellingLabel: 'AI 故事呈现',
        storytellingTitle: '自动发布案例和后续沟通材料',
        storytellingHighlights: [
          'AI 模板把求职管线数据转成作品集、案例和复盘。',
          '个性化感谢邮件和状态更新一键生成。',
          '托管在自动更新的品牌化微站点上。',
        ],
        trackingDescription: '按阶段触发的自动化让沟通、内推和面试在各个视图中同步。',
        trackingLabel: '智能追踪',
        trackingTitle: '让每次沟通都能继续推进的求职 CRM',
        trackingHighlights: [
          '两次点击即可在看板、表格和日历中同步阶段变化。',
          '备注、文件和面试准备清单固定在对应机会下。',
          '自动安排外联、内推和跟进提醒。',
        ],
      },
      stats: {
        error: '统计数据加载失败',
        impactDescription: '来自真实用户的真实结果。看看 JobJourney 如何改变求职体验。',
        impactTitle: '我们的影响力数据',
        jobsDiscovered: '发现职位',
        jobsDiscoveredDescription: '跨平台发现的机会',
        jobsTracked: '追踪职位',
        jobsTrackedDescription: '通过 JobJourney 管理的申请',
        successfulOffers: '成功 Offer',
        successfulOffersDescription: '帮助用户拿下的理想工作',
        usersHelped: '帮助用户',
        usersHelpedDescription: '获得职业方向支持的求职者',
      },
      table: {
        application: '个申请',
        applications: '个申请',
        defaultApplications: [
          {
            company: 'Nimbus Analytics',
            date: '2024 年 11 月 4 日',
            location: '远程 - 美国',
            nextStep: '作品集讲解 - 11 月 7 日',
            role: '高级产品设计师',
            stage: '面试已安排',
          },
          {
            company: 'Brightleaf Labs',
            date: '2024 年 11 月 2 日',
            location: 'Austin, TX',
            nextStep: '11 月 9 日前完成案例研究',
            role: '增长营销经理',
            stage: '测评已发送',
          },
          {
            company: 'Atlas Support Co.',
            date: '2024 年 10 月 29 日',
            location: 'Toronto, CA',
            nextStep: '复查薪酬备注',
            role: '客户成功负责人',
            stage: 'Offer 审核中',
          },
          {
            company: 'Riverstone Tech',
            date: '2024 年 10 月 27 日',
            location: 'Chicago, IL',
            nextStep: '发送跟进消息',
            role: '全栈工程师',
            stage: '等待回复',
          },
        ],
        defaultSubtitle: '来自 JobJourney 跟踪器的实时更新',
        defaultTitle: '进行中的申请',
        nextStep: '下一步',
        opportunity: '机会',
        stage: '阶段',
        synced: '刚刚同步',
        tracking: '正在追踪',
        updated: '更新',
      },
      story: {
        applyAria: '用更好的材料申请',
        applyDescription:
          '利用你的资料、项目、保存职位和面试备注，为招聘人员生成更精准的求职信、跟进消息和作品集页面。',
        applyHeadline: '带着\n证明\n申请',
        applyLabel: '把求职进展变成更强的申请材料',
        applyMaterial: '申请材料',
        applicationDashboard: '申请仪表盘',
        aiEvaluation: 'AI 评估',
        contextAria: '把职位上下文放在一起',
        contextDescription:
          '保存职位不应该只是保存链接。JobJourney 会把职位、备注、下一步和 AI 帮助放在一起，让你随时继续推进。',
        contextHeadline: '保留\n完整\n上下文',
        contextLabel: '每个职位都有真正重要的信息',
        findAria: '更快找到相关职位',
        findDescription:
          '搜索求职者常用的平台，把有潜力的职位放进一个清晰 shortlist，不再散落在浏览器标签页里。',
        findHeadline: '更快\n找到\n职位',
        findLabel: '少切标签，多看好职位',
        fitAria: '申请前知道该改什么',
        fitDescription: '把 CV 和职位对比，看到优势并补齐缺口，避免继续发送泛泛的申请。',
        fitHeadline: '了解\n你的\n匹配度',
        fitLabel: '提交前获得简历反馈',
        followUps: '跟进和提醒会成为职位记录的一部分',
        jobJourneyStory: 'JobJourney 产品故事',
        multiPlatformSearch: '多平台搜索',
        pipelineAria: '追踪每一个下一步',
        pipelineDescription:
          '清楚看到今天需要关注什么：要申请的职位、要准备的面试、要跟进的招聘人员，以及要比较的 Offer。',
        pipelineHeadline: '追踪\n每个\n步骤',
        pipelineLabel: '不再依赖混乱表格',
        portfolioAndDocuments: '作品集和文档',
        roleContext: '公司、职位、来源、薪资线索和备注都保留在一起',
        roleDetailWorkspace: '职位详情工作区',
        startFree: '免费开始',
        strongMatch: '高度匹配',
        sourceIndeed: '不用多开标签也能获得额外信号',
        sourceLinkedIn: '值得查看的职位',
        sourceSeek: '本地市场覆盖',
        stageApplied: '记录提交',
        stageInterview: '准备下一场面试',
        stageOffer: '比较结果',
        stageSaved: '加入 shortlist',
        suggestionContext: 'AI 建议会关联到你正在查看的职位',
        signalActualRole: '针对真实职位展示优势、缺失关键词和修改建议',
        signalFollowUp: '用面试备注和结果让每次跟进都更具体',
        signalGenerate: '从你已经维护的资料生成申请材料',
        signalRecruiters: '向招聘人员展示匹配该职位的项目和证明',
      },
      testimonials: {
        eyebrow: '用户反馈',
        subtitle: '点击任意头像，看看 JobJourney 如何帮助求职者更顺畅地搜索、追踪和申请。',
        title: '求职者正在做出更清晰的选择',
      },
    },
    aiLab: {
      error: '错误',
      subtitle: '用 AI 加速你的求职流程',
      title: 'AI 实验室',
    },
    router: {
      loading: '加载中...',
    },
  },
} as const;

export type TranslationCatalog = typeof translations;
export type TranslationTree = TranslationCatalog[keyof TranslationCatalog];
